var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalmAppSquare = function SvgCalmAppSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#calm-app-square_svg__a)",
    fillRule: "evenodd",
    d: "M18.656 0H5.344A5.344 5.344 0 0 0 0 5.344v13.312A5.344 5.344 0 0 0 5.344 24h13.312A5.344 5.344 0 0 0 24 18.656V5.344A5.344 5.344 0 0 0 18.656 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#calm-app-square_svg__b)",
    fillRule: "evenodd",
    d: "M18.656 0H5.344A5.344 5.344 0 0 0 0 5.344v13.312A5.344 5.344 0 0 0 5.344 24h13.312A5.344 5.344 0 0 0 24 18.656V5.344A5.344 5.344 0 0 0 18.656 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.646 9.759c-.317.4-.6.85-.821 1.338a6.2 6.2 0 0 0-.477 1.559c-.424 2.99 1.394 3.466 1.704 3.524 1.594.186 2.768-.682 3.322-1.215.2.998 1.197 1.01 1.634.56a1.48 1.48 0 0 0 .27-.404c.26.944 1.09.622 1.188.58.463-.173.947-.818 1.29-1.36.217.743.636 1.538 1.443 1.453.486-.012 1.704-1.308 1.817-1.14.112.14.142.398.135.781-.008.383.297.403.434.365.213-.06.347-.48.57-.844a3.8 3.8 0 0 1 .478-.64c.088-.093.483-.503.762-.364.28.14.308.425.327.583.021.159.022.327.028.511-.008.635.29.725.374.748.69.186.733-1.111 1.238-1.593.048-.049.49-.506.742.24.365 1.346 1.486 1.85 2.997 1.101.28-.139.335-.193.488-.307a.15.15 0 0 0 .059-.117v-.002a.147.147 0 0 0-.218-.128h-.001c-.155.086-.669.258-.832.317-.61.1-1.356.077-1.723-.814a3.25 3.25 0 0 0-.41-.765c-.214-.288-.915-.63-1.57-.013a2.4 2.4 0 0 0-.405.501q-.066.105-.124.212l-.008-.028c-.058-.2-.243-.937-1.012-1.057-.106-.009-.535-.057-1.127.594a5.6 5.6 0 0 0-.54.71 1.1 1.1 0 0 0-.097-.306c-.504-.775-1.266-.156-1.595.075-.736.518-1.077 1.215-1.526-.367a7 7 0 0 1-.14-.68c.448-.76 1.358-3.074.836-4.626-.034-.098-.216-.598-.654-.566-.062.006-.56-.046-.833 1.347-.255 1.347-.198 3.084-.136 3.66.007.059.02.177.043.33-.431.74-.997 1.579-1.342 1.618-.448.05-.323-.363-.597-1.281-.047-.12-.198-.687-.878-.659-.332.014-.684.1-1.165.627-.78.854-2.56 2.14-3.833 1.332-.138-.107-.826-.67-.573-2.357a5.38 5.38 0 0 1 .409-1.345 6 6 0 0 1 .699-1.18C4.604 8.66 5.736 8.473 5.96 8.483c.573 0 .722.743.722.736a.237.237 0 1 0 .471-.046c0-.007.002-.243-.096-.467-.09-.293-.349-.564-.5-.664-.185-.13-.43-.199-.72-.199-.832 0-2.026.57-3.19 1.917m8.57 2.346c-.007-2.619.326-3.213.35-3.167.127.235.4 1.71-.346 3.321zm-4.314 2.573c.01-.693.871-1.128 1.103-.646q.026.061.044.128c-.04.128-.056.333-.192.612-.143.295-.368.44-.563.44-.217 0-.397-.178-.392-.534",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calm-app-square_svg__a",
    x1: 12,
    x2: 12,
    y1: 24,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BBEEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calm-app-square_svg__b",
    x1: -0.04,
    x2: 13.224,
    y1: 34.673,
    y2: 9.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793BEB",
    stopOpacity: 0
  })))));
};
export default SvgCalmAppSquare;